export default {
  NODE_ENV: `${process.env.NODE_ENV}`,
  SDK_API_URL: `${process.env.SDK_API_URL}`,
  SIFT_KEY: `${process.env.SIFT_KEY}`,
  DOMAIN: `${process.env.DOMAIN}`,
  DEFAULT_CITY_SLUG: `${process.env.DEFAULT_CITY_SLUG}`,
  DEFAULT_CITY_ID: `${process.env.DEFAULT_CITY_ID}`,
  ROLLBAR_ACCESS_TOKEN: `${process.env.ROLLBAR_ACCESS_TOKEN}`,
  ROLLBAR_ENABLE: `${process.env.ROLLBAR_ENABLE}`,
  GOOGLE_MAPS_API_URL: `${process.env.GOOGLE_MAPS_API_URL}`,
  GOOGLE_MAPS_API_KEY: `${process.env.GOOGLE_MAPS_API_KEY}`,
  TL_API_KEY: `${process.env.TL_API_KEY}`,
  SEGMENT_WRITE_KEY: `${process.env.SEGMENT_WRITE_KEY}`,
  SEGMENT_DEBUG: `${process.env.SEGMENT_DEBUG}`,
  TABLELIST_API_BASE_URL: `${process.env.TABLELIST_API_BASE_URL}`,
  BRAZE_API_KEY: `${process.env.BRAZE_API_KEY}`,
  AUTH_TOKEN: `${process.env.AUTH_TOKEN}`,
  PROSPECT_TOKEN: `${process.env.PROSPECT_TOKEN}`
};



// WEBPACK FOOTER //
// ./src/config.js